var map = {
	"./goldcoin/index-icon-small-coin.png": 72070,
	"./memetown/index-icon-small-coin.png": 96817,
	"./reflection/index-icon-small-coin.png": 72572,
	"./tapcoin/index-icon-small-coin.png": 68841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26552;